// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"01ae7135","826":"09cccd47"}[chunkId] + ".chunk.js";
};